import ReporteAvisosRow from "./ReporteAvisosRow";

const ReporteAvisosTable = ({ reports }) => {
  return (
    <table className="w-full table-auto border-separate">
      <thead className="sticky top-0 z-10 bg-backgroundColor">
        <tr className="text-left font-semibold font-sans text-black">
          <th />
          <th className="pl-1">Título del aviso</th>
          <th className="text-center">Categoría</th>
          <th className="text-center">Fecha de envío</th>
          <th className="text-center">Enviado a</th>
          <th className="text-center">Leído por</th>
          <th className="text-center">Sin leer por</th>
          <th className="text-center">Acciones</th>
        </tr>
      </thead>
      <tbody>
        {reports?.map((report) => (
          <ReporteAvisosRow key={report?._id} report={report} />
        ))}
      </tbody>
    </table>
  );
};

export default ReporteAvisosTable;
